var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "container content-padding" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("h2", { staticClass: "text-center" }, [
            _vm._v("\n            Terms of Service\n            "),
            _c("br"),
            _vm._v(
              "\n            ข้อตกลงการใช้บริการของลูกค้าบีนีท\n          "
            )
          ]),
          _vm._v(" "),
          _c("div", [_vm._v(" ")]),
          _vm._v(" "),
          _c("div", [
            _c("p", { staticClass: "font-weight-bold" }, [
              _vm._v("ข้อสำคัญ:  โปรดพิจารณาทบทวนข้อตกลงนี้อย่างรอบคอบ")
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "บีนีทขอให้ท่านพิจารณาทบทวนข้อตกลงนี้อย่างรอบคอบ ว่าท่านได้อ่านและเข้าใจเนื้อหาและยอมรับข้อตกลงนี้ดีแล้วก่อนเริ่มการใช้บริการของบีนีท"
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "ข้อกำหนดและเงื่อนไขตามที่ระบุในเอกสารนี้ (รวมเรียกว่า “ข้อตกลง” ฉบับนี้) ให้ถือเป็นข้อตกลงทางกฎหมายระหว่างท่าน และบริษัท บีนีท จำกัด (“บีนีท”หรือ “เรา”) ท่านตกลงและยอมรับเงื่อนไขตามที่ระบุไว้ด้านล่าง ทั้งนี้ การใช้แพลตฟอร์มที่บีนีทจัดเตรียมให้ (“บีนีทแพลตฟอร์ม”) ด้วยการดาวน์โหลด ติดตั้งหรือใช้ซอฟต์แวร์ใดๆ ที่เกี่ยวข้องตามที่บีนีทได้จัดเตรียมไว้ให้ ซึ่งมีวัตถุประสงค์โดยรวมเพื่อให้ท่านสามารถใช้บริการการทำความสะอาดหรือบริการอื่นๆ ที่กำหนดไว้ โดยที่ท่านและ/หรือบีนีทเป็นผู้มีสิทธิเลือกรูปแบบการรับบริการจากผู้ให้บริการอิสระ (“ผู้ให้บริการอิสระ”) ในแต่ละงานจ้างตามแต่ความต้องการ (รวมเรียกว่า “การบริการ”) ท่านยอมรับและตกลงโดยชัดแจ้งที่จะผูกพันตามเงื่อนไขที่ปรากฏในเว็บไซต์นี้ รวมถึงการแก้ไขและการเพิ่มเติมใดๆ ของเงื่อนไขที่อาจมีขึ้นในอนาคตซึ่งได้มีการประกาศล่าสุดในเว็บไซต์ "
              ),
              _c("a", { attrs: { href: "https://www.BeNeat.co" } }, [
                _vm._v("www.BeNeat.co")
              ]),
              _vm._v(" หรือผ่านทางบีนีทแพลตฟอร์ม")
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "บีนีทขอสงวนสิทธิ์ในการแก้ไข ทำให้แตกต่าง และเปลี่ยนแปลงข้อกำหนดและเงื่อนไข หรือนโยบายของบีนีทที่เกี่ยวกับการบริการไม่ว่าเวลาใดตามที่บีนีทเห็นสมควร โดยจะมีผลบังคับใช้ต่อเมื่อมีการประกาศเงื่อนไขในการใช้บริการหรือนโยบายใดๆ ของบีนีทฉบับล่าสุด ท่านตกลงว่าการอ่านข้อตกลงนี้อย่างสม่ำเสมอเป็นความรับผิดชอบของท่านเอง และให้ถือว่าท่านได้ให้ความยินยอมและยอมรับการเปลี่ยนแปลงดังกล่าวแล้ว (หากมี)"
              )
            ]),
            _vm._v(" "),
            _c("ol", { staticClass: "head__line" }, [
              _c("li", { staticClass: "font-weight-bold li__head__line" }, [
                _vm._v("ความเป็นมาและลักษณะของบีนีทแพลตฟอร์ม")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "บีนีทเป็นผู้สร้างแพลตฟอร์มเทคโนโลยีเพื่อให้บริการต่างๆ เช่น บริการเกี่ยวกับบ้าน และ/หรือทำความสะอาดสำนักงาน บริการรีดผ้า นวดแผนไทย บริการกำจัดไรฝุ่น และรับจ้างทำงานเล็กๆ น้อยๆ หรืองานใดๆ ที่ปรากฏบนบีนีทแพลตฟอร์ม โดยบีนีทจะคัดเลือกหรือทำการจัดหาและ/หรือจัดจ้างผู้ให้บริการอิสระ (Service Provider) ที่มีใบอนุญาต (กรณีงานดังกล่าวมีกฎหมายกำหนดให้ต้องมีใบอนุญาต) ให้แก่ลูกค้า (Client) หรือลูกค้าอาจเลือกตัวผู้ให้บริการอิสระด้วยตัวเองผ่านบีนีทแพลตฟอร์มได้ โดยบีนีทมีหน้าที่เสนอข้อมูลโปรไฟล์ของผู้ให้บริการอิสระและวิธีการในการบริการต่างๆ ให้แก่ลูกค้า ซึ่งลูกค้าสามารถเลือกการบริการและตัวผู้ให้บริการอิสระได้ตามความพอใจผ่านข้อมูลและช่องทางที่บีนีทจัดเตรียมให้ ทั้งนี้ ในการรับงานบีนีทจะเป็นผู้รับงานจากลูกค้าโดยตรง"
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "บีนีทเป็นผู้จัดให้บริการ web-based และ mobile application-based portal รวมเรียกว่า บีนีทแฟลตฟอร์ม (BeNeat Platform) โดยท่านอาจติดต่อขอรับบริการผ่านบีนีทแฟลตฟอร์มซึ่งมีบริการที่หลากหลายตามความประสงค์ของลูกค้า หรืออาจติดต่อขอรับบริการจากผู้ดูแลระบบ (Admin) ของบีนีทผ่านไลน์แอปพลิเคชันซึ่งเป็นอีกช่องทางการสื่อสารของบีนีท ผู้ดูแลระบบจะดำเนินการจองงานและให้ความช่วยเหลือในเรื่องต่างๆ อันเกี่ยวกับการบริการแก่ลูกค้า"
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "อนึ่ง ท่านรับทราบและเข้าใจว่า ความสัมพันธ์ระหว่างบีนีทและผู้ให้บริการอิสระของบีนีท ไม่ใช่ความสัมพันธ์ในฐานะลูกจ้าง คนงาน  ผู้ร่วมทุน หุ้นส่วน หรือ ผู้ได้รับสิทธิพิเศษในการให้บริการจากบีนีท หรือลูกค้าอย่างหนึ่งอย่างใดทั้งสิ้น"
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "font-weight-bold li__head__line" }, [
                _vm._v("คำจำกัดความ")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "คำต่าง ๆ ที่ระบุในข้อตกลงการให้บริการนี้ มีความหมายดังต่อไปนี้"
                )
              ]),
              _vm._v(" "),
              _c("table", [
                _c("tr", { staticClass: "mb-2" }, [
                  _c("td", { staticClass: "font-weight-bold td1" }, [
                    _vm._v("“บีนีท หรือ เรา ”")
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "td2" }, [_vm._v("หมายถึง")]),
                  _vm._v(" "),
                  _c("td", { staticClass: "td3" }, [
                    _vm._v("บริษัท บีนีท จำกัด")
                  ])
                ]),
                _vm._v(" "),
                _c("tr", { staticClass: "mb-2" }, [
                  _c("td", { staticClass: "font-weight-bold td1" }, [
                    _vm._v("“บีนีทแพลตฟอร์ม”")
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "td2" }, [_vm._v("หมายถึง")]),
                  _vm._v(" "),
                  _c("td", { staticClass: "td3" }, [
                    _vm._v(
                      "แพลตฟอร์มเทคโนโลยีที่บีนีทสร้างขึ้นบนเว็บไซต์ (web-based) และ แอปพลิเคชันบนมือถือ (mobile application-based  portal) เพื่อให้บริการต่างๆ แก่ลูกค้า โดยบีนีทจะเป็นผู้รับงานจากลูกค้า (Client) และจะจัดหา/จัดจ้างผู้ให้บริการอิสระ (Service Provider) เพื่อให้บริการตามความประสงค์แก่ว่าที่ลูกค้าบนบีนีทแพลตฟอร์ม"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("tr", { staticClass: "mb-2" }, [
                  _c("td", { staticClass: "font-weight-bold td1" }, [
                    _vm._v("“ผู้ให้บริการอิสระ”")
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "td2" }, [_vm._v("หมายถึง")]),
                  _vm._v(" "),
                  _c("td", { staticClass: "td3" }, [
                    _vm._v(
                      "สมาชิกของบีนีทแพลตฟอร์มที่ผ่านการตรวจสอบคุณสมบัติตามที่บีนีทกำหนดและได้รับอนุมัติให้สามารถเป็นผู้ให้บริการอิสระ (Service Provider) บนบีนีทแพลตฟอร์ม"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("tr", { staticClass: "mb-2" }, [
                  _c("td", { staticClass: "font-weight-bold td1" }, [
                    _vm._v("“ลูกค้า หรือ ท่าน”")
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "td2" }, [_vm._v("หมายถึง")]),
                  _vm._v(" "),
                  _c("td", { staticClass: "td3" }, [
                    _vm._v(
                      "บุคคลหรือนิติบุคคลที่ตกลงใช้บริการบนบีนีทแพลตฟอร์มโดยทำการจองใช้บริการและและตกลงจ้างบีนีทเพื่อใช้บริการนั้นๆโดยผ่านกระบวนการและวิธีการตามที่บีนีทแพลตฟอร์มกำหนด "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("tr", { staticClass: "mb-2" }, [
                  _c("td", { staticClass: "font-weight-bold td1" }, [
                    _vm._v("“โปรไฟล์ผู้ให้บริการอิสระ”")
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "td2" }, [_vm._v("หมายถึง")]),
                  _vm._v(" "),
                  _c("td", { staticClass: "td3" }, [
                    _vm._v(
                      "โปรไฟล์ที่ผู้ให้บริการอิสระสร้างขึ้นบนบีนีทแพลตฟอร์มโดยแสดงข้อมูลส่วนบุคคลของตน เช่น ชื่อ เพศ อายุ ประสบการณ์ทำงาน ตัวอย่างผลงาน เป็นต้น เพื่อให้ลูกค้าสามารถพิจารณาคุณสมบัติของผู้ให้บริการอิสระและเพื่อวัตถุประสงค์ในการใช้งานของบีนีทแพลตฟอร์ม"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("tr", { staticClass: "mb-2" }, [
                  _c("td", { staticClass: "font-weight-bold td1" }, [
                    _vm._v("“โปรไฟล์ของลูกค้า”")
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "td2" }, [_vm._v("หมายถึง")]),
                  _vm._v(" "),
                  _c("td", { staticClass: "td3" }, [
                    _vm._v(
                      "โปรไฟล์ที่ลูกค้าสร้างขึ้นบนบีนีทแพลตฟอร์มโดยแสดงข้อมูลส่วนบุคคลของตน เช่น ชื่อ เพศ  ที่อยู่ เบอร์โทรศัพท์ อีเมล์ เป็นต้น เพื่อวัตถุประสงค์ในการใช้งานบีนีทแพลตฟอร์ม"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("tr", { staticClass: "mb-2" }, [
                  _c("td", { staticClass: "font-weight-bold td1" }, [
                    _vm._v("“กลุ่มของบีนีท”")
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "td2" }, [_vm._v("หมายถึง")]),
                  _vm._v(" "),
                  _c("td", { staticClass: "td3" }, [
                    _vm._v(
                      "บีนีท บริษัทในเครือบีนีท และ/หรือ บริษัทที่ควบคุมร่วมกันของบีนีทกับตัวแทนของบีนีท และตัวแทนของกลุ่มบีนีท ผู้จัดทำซึ่งเป็นบุคคลภายนอก ผู้พัฒนา ผู้จัดทำโฆษณา คู่ค้า บริษัทที่จัดงาน หรือผู้สนับสนุนของกลุ่มบีนีทผู้ซึ่งอาจติดต่อสื่อสารกับท่านไม่ว่าด้วยเหตุผลประการใดก็ตาม"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("tr", { staticClass: "mb-2" }, [
                  _c("td", { staticClass: "font-weight-bold td1" }, [
                    _vm._v("“บริการ”")
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "td2" }, [_vm._v("หมายถึง")]),
                  _vm._v(" "),
                  _c("td", { staticClass: "td3" }, [
                    _vm._v(
                      "บริการประเภทต่างๆ ที่บีนีทนำเสนอบนบีนีทแพลตฟอร์ม เช่น งานเกี่ยวกับบ้าน และ/หรือ ทำความสะอาดสำนักงาน บริการรีดผ้า นวดแผนไทย บริการกำจัดไรฝุ่นและรับจ้างทำงานเล็กๆ น้อยๆ หรือ งานอื่นๆ ที่ตามความพอใจของลูกค้าและเป็นไปตามความเหมาะสมซึ่งบีนีทเห็นควร"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("tr", { staticClass: "mb-2" }, [
                  _c("td", { staticClass: "font-weight-bold td1" }, [
                    _vm._v("“แอปพลิเคชัน”")
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "td2" }, [_vm._v("หมายถึง")]),
                  _vm._v(" "),
                  _c("td", { staticClass: "td3" }, [
                    _vm._v(
                      "โปรแกรมที่ถูกออกแบบสำหรับอุปกรณ์อิเล็กทรอนิกส์แบบพกพาที่สร้างขึ้นเพื่อการให้บริการ"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("tr", { staticClass: "mb-2" }, [
                  _c("td", { staticClass: "font-weight-bold td1" }, [
                    _vm._v("“ไลน์แอปพลิเคชัน”")
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "td2" }, [_vm._v("หมายถึง")]),
                  _vm._v(" "),
                  _c("td", { staticClass: "td3" }, [
                    _vm._v(
                      "แอปพลิเคชั่นที่สร้างขึ้นเพื่อการให้บริการด้านการสื่อสารซึ่งบีนีทมีบัญชีผู้ใช้งานที่สามารถติดต่อสื่อสารแจ้งข้อมูลข่าวสารกับลูกค้าผ่านช่องทางทางดังกล่าวได้"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("tr", { staticClass: "mb-2" }, [
                  _c("td", { staticClass: "font-weight-bold td1" }, [
                    _vm._v("“ข้อมูลส่วนบุคคล”")
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "td2" }, [_vm._v("หมายถึง")]),
                  _vm._v(" "),
                  _c("td", { staticClass: "td3" }, [
                    _vm._v(
                      "ข้อมูลที่ใช้ในการยืนยันตัวตนของบุคคล ซึ่งรวมถึงแต่ไม่จำกัดเพียง ชื่อ สัญชาติ เบอร์โทรศัพท์ ข้อมูลธนาคารและบัตรเครดิต ความสนใจส่วนตัว อีเมล์ หมายเลขบัตรประจำตัวประชาชน ข้อมูลทางชีวภาพ เชื้อชาติ วันเกิด สถานภาพสมรส ศาสนา ข้อมูลสุขภาพ ข้อมูลยานพาหนะและประกันภัย"
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "font-weight-bold li__head__line" }, [
                _vm._v("การบริการ ")
              ]),
              _vm._v(" "),
              _c("ol", { staticClass: "list3" }, [
                _c(
                  "li",
                  { staticClass: "my-2", attrs: { "aria-current": "list3_1" } },
                  [
                    _vm._v(
                      "บีนีทจะเสนอการบริการและข้อมูลการให้บริการบนบีนีทแพลตฟอร์ม ลูกค้าสามารถเลือกใช้บริการต่างๆ ของบีนีท ผ่านขั้นตอนและกระบวนการที่บีนีทกำหนด บีนีทจะนำเสนอข้อมูลการการให้บริการ รวมถึงข้อมูลโปรไฟล์ของผู้ให้บริการอิสระที่บีนีทเห็นว่ามีคุณสมบัติและเหมาะสมที่จะให้บริการแก่ลูกค้า ท่านสามารถเลือกผู้ให้บริการอิสระได้ด้วยตนเองหรือบีนีทอาจดำเนินการเลือกผู้ให้บริการอิสระเองหากเป็นความประสงค์ของลูกค้า\n                   "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "my-2", attrs: { "aria-current": "list3_2" } },
                  [
                    _vm._v(
                      "ประเภทงานบริการที่ผู้ให้บริการอิสระให้บริการ อาทิ\n                        "
                    ),
                    _c("ul", { staticClass: "mar3rem" }, [
                      _c("li", [_vm._v("การบริการทำความสะอาดต่างๆ ")]),
                      _vm._v(" "),
                      _c("li", [_vm._v("การบริการรีดผ้า ")]),
                      _vm._v(" "),
                      _c("li", [_vm._v("การบริการนวดแผนไทย")]),
                      _vm._v(" "),
                      _c("li", [_vm._v("บริการกำจัดไรฝุ่น")]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "และอื่นๆ ซึ่งอาจมีการกำหนดรายละเอียดเพิ่มเติมในบีนีทแพลตฟอร์ม"
                        )
                      ])
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "font-weight-bold li__head__line" }, [
                _vm._v("ขั้นตอนการจองงานบริการ")
              ]),
              _vm._v(" "),
              _c("ol", { staticClass: "list4" }, [
                _c(
                  "li",
                  { staticClass: "my-2", attrs: { "aria-current": "list4_1" } },
                  [
                    _vm._v(
                      "เมื่อท่านต้องการจองงานบริการ ท่านจะสามารถจองงานได้ผ่านบีนีทแพลตฟอร์มหรือไลน์แอปพลิเคชันในกรณีเร่งด่วนที่ต้องการการบริการภายใน 24 ชั่วโมงนับตั้งแต่การจอง ท่านสามารถแจ้งความประสงค์ผ่านทางไลน์แอปพลิเคชันเพื่อให้ผู้ดูแลระบบดำเนินการจองงานให้เท่านั้น ทั้งนี้ท่านทราบดีว่า ในบางคราวบีนีทอาจไม่สามารถจัดหาผู้ให้บริการอิสระในงานเร่งด่วนนั้นได้ ทั้งนื้ ขึ้นอยู่กับความพร้อมของผู้ให้บริการอิสระและปัจจัยต่างๆ ประกอบกัน"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "my-2", attrs: { "aria-current": "list4_2" } },
                  [
                    _vm._v(
                      "ในการจองงาน ท่านจะต้องเลือกประเภทงานบริการและตอบคำถามตามที่บีนีทแพลตฟอร์มกำหนด รวมถึงจะต้องบอกความต้องการเกี่ยวกับงานบริการนั้นๆ เช่น ขนาดของพื้นที่ที่ต้องการทำความสะอาด จำนวนผ้าที่ท่านต้องการจะรีด ข้อมูลเกี่ยวกับสถานที่ซึ่งท่านต้องการให้ผู้ให้บริการอิสระเข้าไปบริการ และระยะเวลาที่ท่านต้องการใช้บริการ เป็นต้น "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "my-2", attrs: { "aria-current": "list4_3" } },
                  [
                    _vm._v(
                      "หลังจากท่านเลือกการบริการและแสดงข้อมูลความต้องการตามที่บีนีทแพลตฟอร์มสอบถามแล้ว ท่านสามารถเลือกผู้ให้บริการอิสระที่จะทำงานบริการนั้นแก่ท่านด้วยตัวเอง โดยบีนีทอาจนำเสนอผู้ให้บริการอิสระที่เหมาะสมโดยอาศัยฐานข้อมูลของบีนีท ท่านสามารถเข้าไปดูโปร์ไฟล์ของผู้ให้บริการอิสระได้เพื่อการพิจารณา โดยในโปร์ไฟล์ของผู้ให้บริการอิสระจะมีข้อมูลส่วนตัว ประวัติการทำงาน ผลงาน หรืออุปกรณ์ต่างๆ ที่ใช้ในการทำงานบริการนั้นๆ "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "my-2", attrs: { "aria-current": "list4_4" } },
                  [
                    _vm._v(
                      "เมื่อท่านทำการเลือกผู้ให้บริการอิสระเรียบร้อยแล้ว หากผู้ให้บริการอิสระที่ถูกเลือกกดตอบรับงานของท่านบนบีนีทแพลตฟอร์ม บีนีทจะดำเนินการต่างๆ ต่อไปเพื่อให้ขั้นตอนจองงานสมบูรณ์ แต่หากผู้ให้บริการอิสระรายดังกล่าวไม่กดตอบรับงาน ท่านจะต้องเลือกผู้ให้บริการอิสระคนใหม่จนกว่าจะมีการกดรับงานจากผู้ให้บริการอิสระ หรือท่านอาจตกลงให้บีนีทจัดหาผู้ให้บริการที่มีความพร้อมในการรับงานของท่านก็ได้"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "my-2", attrs: { "aria-current": "list4_5" } },
                  [
                    _vm._v(
                      "ในกรณีที่ลูกค้าไม่ได้ระบุตัวผู้ให้บริการอิสระและต้องการให้บีนีทเป็นผู้จัดหาผู้ให้บริการอิสระที่เหมาะสมให้ บีนีทจะคัดเลือกผู้ให้บริการอิสระที่เหมาะสมกับงานนั้นๆ โดยพิจารณาจากตำแหน่งที่อยู่ (Location) ของผู้ให้บริการ กับสถานที่ให้บริการ ประสบการณ์ และผลสำเร็จของงานที่ผ่านมาเป็นสำคัญ ในกรณีนี้บีนีทอาจส่งข้อมูลของงานไปให้ผู้ให้บริการอิสระ ซึ่งอาจมีมากกว่า 1 (หนึ่ง) ราย ผู้ให้บริการอิสระที่กดรับงานก่อนจะเป็นผู้ที่ได้รับงานนั้น บีนีทจะดำเนินการจองงานและแจ้งให้ท่านทราบพร้อมแสดงข้อมูลของผู้ให้บริการอิสระรายดังกล่าว"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "my-2", attrs: { "aria-current": "list4_6" } },
                  [
                    _vm._v(
                      "เมื่อระบุตัวผู้ให้บริการอิสระได้แล้ว ท่านจะต้องชำระเงินค่าบริการตามยอดที่ปรากฏบนบีนีทแพลตฟอร์มโดยจะพิจารณาตามขอบเขตงานที่ได้มีการระบุไว้เบื้องต้น พร้อมแสดงหลักฐานการชำระเงินตามขั้นตอนที่บีนีทแพลตฟอร์มกำหนดเพื่อให้ขั้นตอนการจองงานเสร็จสมบูรณ์ หลังจากได้รับเงินแล้ว ระบบจะแจ้งยืนยันการชำระเงิน ในกรณีที่ท่านต้องการใบเสร็จรับเงินท่านจะต้องแจ้งให้ระบบทราบถึงความต้องการดังกล่าว"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "my-2", attrs: { "aria-current": "list4_7" } },
                  [
                    _vm._v(
                      "บีนีทจะเป็นผู้รับงานจากลูกค้าและจะว่าจ้างผู้ให้บริการอิสระที่ได้รับเลือกให้เป็นผู้ให้บริการแก่ลูกค้า หลังจากการจองงานเสร็จสมบูรณ์แล้ว ก่อนเริ่มงาน บีนีทจะส่งสัญญาจ้างงานและรายละเอียดในการบริการ (Work Order) ให้แก่ท่านล่วงหน้าเพื่อให้ท่านยอมรับและลงนามทางอิเล็กทรอนิกส์ต่อไป โดยท่านจะต้องตรวจสอบและอ่านเอกสารดังกล่าวก่อนกดยอมรับการลงนามเสมอ"
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "font-weight-bold li__head__line" }, [
                _vm._v("การบริการ")
              ]),
              _vm._v(" "),
              _c("ol", { staticClass: "list5" }, [
                _c(
                  "li",
                  { staticClass: "my-2", attrs: { "aria-current": "list5_1" } },
                  [
                    _vm._v(
                      "ก่อนการเข้าบริการ บีนีทอาจจะทำการแจ้งเตือนนัดหมายการบริการที่ได้มีการจองการบริการไว้ล่วงหน้า โดยจะยืนยันข้อมูลการบริการ เวลาและสถานที่ทำงานที่ท่านต้องการรับบริการ ผ่านช่องทางการสื่อสารที่ท่านได้ให้ไว้กับบีนีท"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "my-2", attrs: { "aria-current": "list5_2" } },
                  [
                    _vm._v(
                      "ในวันนัดหมาย ผู้ให้บริการอิสระจะไปถึงสถานที่ทำงานก่อนเวลานัดหมายเล็กน้อยเพื่ออธิบายวิธีการทำงาน พร้อมประเมินงานบริการ ในกรณีที่ผู้ให้บริการอิสระเห็นว่าไม่สามารถให้บริการได้ครบถ้วนตามระยะเวลาที่ลูกค้าเลือกไว้ ผู้ให้บริการอิสระจะแจ้งและประเมินชั่วโมงการทำงานที่เหมาะสมกับการบริการนั้นๆ ให้ลูกค้าทราบ ท่านสามารถตกลงเพิ่มเติมชั่วโมงการทำงานของผู้ให้บริการอิสระของบีนีทหรือไม่ก็ได้ ในกรณีที่ท่านตกลงเพิ่มชั่วโมงการทำงานให้ท่านติดต่อบีนีทเพื่อแจ้งเรื่องพร้อมชำระค่าบริการส่วนต่างจากจำนวนค่าบริการเดิมที่ท่านได้ชำระแล้วในขั้นตอนจองงาน ในกรณีที่ท่านไม่ประสงค์จะเพิ่มชั่วโมงการทำงาน ผู้ให้บริการอิสระจะอธิบายให้ท่านทราบว่าในระยะเวลาที่ท่านเลือกเมื่อพิจารณาจากเนื้องานที่หน้างานผู้ให้บริการอิสระของบีนีทสามารถดำเนินการบริการได้เพียงใด ในกรณีที่ท่านตกลงยอมรับขอบเขตของงานบริการตามที่ผู้ให้บริการอิสระประเมิน ผู้ให้บริการอิสระจะแจ้งเรื่องดังกล่าวมายังบีนีทและหากจำเป็นทางบีนีทอาจพิจารณาส่งข้อความการแก้ไขเกี่ยวกับรายละเอียดของงานเพื่อให้ท่านกดยอมรับผ่านบีนีทแพลตฟอร์ม แต่ในกรณีที่ท่านไม่ตกลงเพิ่มเวลาการให้บริการ ท่านอาจยกเลิกการจองงานได้ อย่างไรก็ตาม เงื่อนไขการรับค่าบริการคืนจะเป็นไปตามข้อ 11 ของข้อตกลงฉบับนี้"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "my-2", attrs: { "aria-current": "list5_3" } },
                  [
                    _vm._v(
                      "กรณีที่ภายในพื้นที่รับบริการมีทรัพย์สินมูลค่าสูงหรือทรัพย์สินที่ทำจากวัสดุซึ่งต้องใช้ความเชี่ยวชาญและความระมัดระวังเป็นพิเศษในการให้บริการเช่น การดูแลทำความสะอาด  เฟอร์นิเจอร์ทำจากพื้นผิวที่ไม่สามารถสัมผัสกับน้ำยาทำความสะอาดบางประเภทได้ หนังสัตว์บางประเภท ผ้าชนิดพิเศษ ขนสัตว์ แจกันหรือโคมแก้วคริสตัลเจียระไน เป็นต้น หรือการให้บริการรีดผ้าที่ทำจากวัสดุที่ต้องใช้ความระมัดระวังเป็นพิเศษ อย่าง ผ้าวู ผ้าไหม ผ้าใยสังเคราะห์บางประเภท เป็นต้น ก่อนการเริ่มให้บริการ ท่านมีหน้าที่แจ้งให้ผู้ให้บริการอิสระของบีนีททราบเป็นลายลักษณ์อักษรล่วงหน้าถึงข้อพึงระวังต่าง ๆ เกี่ยวกับทรัพย์สินเหล่านั้น โดยผู้ให้บริการอิสระของบีนีทจะประเมินความสามารถในการให้บริการ ด้วยอุปกรณ์ตามมาตรฐานของบีนีท ท่านรับทราบและยินยอมว่า หากผู้ให้บริการอิสระประเมินแล้วว่าอุปกรณ์ที่มีไม่สามารถให้บริการแก่ทรัพย์สินบางชิ้น ผู้ให้บริการอิสระสามารถปฏิเสธการให้บริการเช่น ปฎิเสธการทำความสะอาดตัวทรัพย์สินชิ้นนั้น หรือ ปฏิเสธไม่รีดผ้าชิ้นนั้นได้ ทั้งนี้เพื่อหลีกเลี่ยงความเสียหายที่อาจเกิดขึ้น โดยผู้ให้บริการอิสระจะยังคงให้บริการทำความสะอาดบริเวณพื้นที่โดยรอบตามเนื้องานเดิม หรือยังคงให้บริการรีดผ้าที่เหลือตามที่ตกลงตามเดิม"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "my-2", attrs: { "aria-current": "list5_4" } },
                  [
                    _vm._v(
                      "กรณีที่ท่านมี เด็ก หรือผู้เยาว์ที่อายุต่ำกว่า 18 ปีอยู่ในความดูแล ท่านจะต้องแจ้งให้ผู้ให้บริการอิสระรับทราบก่อนการเริ่มให้บริการ โดยท่านจะต้องอยู่ในพื้นที่รับบริการเพื่อดูแลผู้เยาว์ไม่ให้รบกวนการทำงานของผู้ให้บริการอิสระและท่านจะต้องไม่ละทิ้งให้ผู้เยาว์อยู่ตามลำพังตลอดช่วงเวลาการให้บริการ ผู้ให้บริการอิสระจะไม่รับฝากหรือรับดูแลผู้เยาว์ไม่ว่ากรณีใดๆ "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "my-2", attrs: { "aria-current": "list5_5" } },
                  [
                    _vm._v(
                      "กรณีที่ท่านมีสัตว์เลี้ยงอยู่ในพื้นที่ให้บริการ ท่านมีหน้าที่แจ้งให้ผู้ให้บริการอิสระของบีนีททราบและท่านต้องรับผิดชอบสัตว์เลี้ยงเสมือนเป็นทรัพย์สินมีมูลค่าชิ้น หนึ่งของท่าน โดยท่านจะต้องดำเนินการจัดการให้สัตว์เลี้ยงอยู่ในพื้นที่ปลอดภัย และไม่รบกวนการทำงานของผู้ให้บริการอิสระ ผู้ให้บริการอิสระจะไม่รับฝากหรือรับดูแลสัตว์เลี้ยงไม่ว่ากรณีใดๆ"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "my-2", attrs: { "aria-current": "list5_6" } },
                  [
                    _vm._v(
                      "เมื่อผู้ให้บริการอิสระเริ่มทำงาน ผู้ให้บริการอิสระจะกดเริ่มงานบนบีนีทแพลตฟอร์ม ระบบจะเริ่มต้นการนับเวลาทำงาน และระบบจะส่งข้อความให้ท่านทราบผ่านทางข้อความโทรศัพท์และ/หรือผ่านบีนีทแพลตฟอร์ม โดยระหว่างการให้บริการหากท่านประสงค์จะเพิ่มชั่วโมงการให้บริการ ท่านสามารถทำการตกลงกับผู้ให้บริการอิสระในจำนวนชั่วโมงบริการที่การต้องการได้ หากผู้ให้บริการอิสระดังกล่าวไม่มีงานอื่นและตกลงให้บริการเพิ่มตามที่ท่านต้องการ ให้ท่านทำการกดเพิ่มชั่วโมงการจองงานบนบีนีทแพลตฟอร์มและทำการชำระเงินตามระยะเวลาที่การต้องรับบริการเพิ่มผ่านช่องทางที่บีนีทแพลตฟอร์มกำหนด"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "my-2", attrs: { "aria-current": "list5_7" } },
                  [
                    _vm._v(
                      "การให้บริการ ในกรณีที่ท่านได้ทำการเลือกผู้ให้บริการอิสระเอง ผู้ให้บริการอิสระรายดังกล่าวจะเป็นผู้ให้บริการ เว้นแต่กรณีจำเป็นอย่างยิ่ง ผู้ให้บริการอิสระคนดังกล่าวไม่สามารถให้บริการตามนัดหมายได้ ในกรณีนี้ท่านอาจขอเปลี่ยนแปลงนัดหมายได้ตามข้อ 11 ของข้อตกลงฉบับนี้\nหากท่านไม่ต้องการเปลี่ยนแปลงนัดการบริการ บีนีทจะรีบดำเนินการหาผู้ให้บริการอิสระรายใหม่ให้แก่ท่าน\tเพื่อให้สามารถบริการท่านได้ตามนัดหมายเดิม อย่างไรก็ตาม หากบีนีทไม่สามารถจัดหาผู้ให้บริการอิสระรายใหม่ให้ท่านได้ และการดังกล่าวไม่ได้เกิดขึ้นเพราะเหตุสุดวิสัยและ/หรือความบกพร่องของท่าน บีนีทตกลงจะคืนเงินค่าบริการที่ได้รับมาแล้วเต็มจำนวน"
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "font-weight-bold li__head__line" }, [
                _vm._v("การรับรองผลงานและการอนุมัติผลงาน")
              ]),
              _vm._v(" "),
              _c("ol", { staticClass: "list6" }, [
                _c(
                  "li",
                  { staticClass: "my-2", attrs: { "aria-current": "list6_1" } },
                  [
                    _vm._v(
                      "บีนีทขอรับรองว่าผู้ให้บริการอิสระของบีนีทเป็นผู้ที่ได้รับคัดเลือกและผ่านการอบรบในการใช้บริการตามมาตรฐานของบีนีทก่อนการเข้าบริการให้แก่ท่าน บีนีท รับรองความพึงพอใจต่อผลงานบริการของเราทั้งนี้ การรับรองความพึงพอใจของผลงานจะไม่ครอบคลุมถึงการใดๆ นอกเหนือขอบเขตของบริการนั้นๆ"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "my-2", attrs: { "aria-current": "list6_2" } },
                  [
                    _vm._v(
                      "เมื่อผู้ให้บริการอิสระของบีนีทได้ทำงานบริการแล้วเสร็จ ท่านสามารถตรวจสอบผลงานงานบริการนั้นๆ หากผลงานการบริการยังไม่เป็นที่พอใจ ท่านอาจขอให้ผู้ให้บริการอิสระแก้ไขเพิ่มเติมได้ ในกรณีที่ท่านพึงพอใจกับงานบริการของบีนีทแล้ว ผู้ให้บริการอิสระจะกดส่งงานผ่านบีนีทแพลตฟอร์มและให้ท่านกดอนุมัติผลงานบริการผ่านบีนีทแพลตฟอร์มเช่นเดียวกัน เมื่อท่านกดอนุมัติผลงานให้ถือว่าได้มีการส่งมอบงานอย่างเสร็จสมบูรณ์ แต่ในกรณีที่ท่านลืมหรือยังไม่ได้กดอนุมัติผลงาน หากพ้นเวลา 24 ชั่วโมงนับแต่เวลาที่ผู้ให้บริการอิสระกดส่งงานมายังบีนีทแล้ว ในช่วงระยะเวลาดังกล่าว หากบีนีทไม่ได้รับแจ้งถึงความชำรุดบกพร่องและ/หรือขอให้มีการแก้ไขผลงานและ/หรือแจ้งถึงความเสียหายต่อทรัพย์สินของท่านอันเนื่องมาจากการทำงานของผู้ให้บริการอิสระ ให้ถือว่าท่านพึงพอใจกับผลงานบริการครั้งนั้นและถือว่าท่านตกลงอนุมัติผลงานบริการแล้ว ณ เวลาที่พ้น 24 ชั่วโมง นับแต่เวลาที่ผู้ให้บริการอิสระกดส่งงานมายังบีนีท"
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "font-weight-bold li__head__line" }, [
                _vm._v("ความรับผิดชอบ ในความชำรุด บกพร่องของงานบริการ")
              ]),
              _vm._v(" "),
              _c("ol", { staticClass: "list7" }, [
                _c(
                  "li",
                  { staticClass: "my-2", attrs: { "aria-current": "list7_1" } },
                  [
                    _vm._v(
                      "ในระหว่างการทำงาน หรือภายใน 24 ชั่วโมง นับจากเวลาที่งานแล้วเสร็จและผู้ให้บริการอิสระได้กดส่งมอบงานดังกล่าวแก่บีนีท หากท่านพบเห็นความชำรุด บกพร่องของงานบริการ หรือพบเห็นความเสียหายของทรัพย์สินของท่านอันเกิดจากการบริการ ท่านจะต้องแจ้งบีนีทถึงความชำรุดบกพร่องหรือเสียหายนั้น ท่านสามารถแจ้งเรื่องดังกล่าวตามช่องทางการติดต่อกับบีนีทที่ระบุไว้ในข้อ 10 แห่งข้อตกลงฉบับนี้ "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "my-2", attrs: { "aria-current": "list7_2" } },
                  [
                    _vm._v(
                      "ในกรณีการชำรุดหรือบกพร่อง บีนีทจะดำเนินการอย่างใดๆ เพื่อให้ผู้ให้บริการอิสระซ่อมแซมความชำรุดบกพร่องดังกล่าวโดยเร็ว หากผู้ให้บริการอิสระรายนั้นไม่สามารถแก้ไขความชำรุดบกพร่องนั้นได้ บีนีทจะดำเนินการให้ผู้ให้บริการอิสระรายอื่นมาแก้ไขความชำรุดบกพร่องดังกล่าวโดยบีนีทจะเป็นผู้รับผิดชอบต่อค่าใช้จ่ายที่เกิดขึ้น"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "my-2", attrs: { "aria-current": "list7_3" } },
                  [
                    _vm._v(
                      "ในกรณีที่เกิดความเสียหายทรัพย์สินของลูกค้าอันเนื่องมาจากการให้บริการของบีนีท บีนีทจะชดใช้ความเสียหายให้แก่ลูกค้าตามมูลค่าทรัพย์สินที่เสียหายจริง ทั้งนี้ บีนีทจะรับผิดไม่เกินวงเงิน 100,000 บาท (หนึ่งแสนบาท) ต่อการบริการ 1 (หนึ่ง) ครั้ง "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "my-2", attrs: { "aria-current": "list7_4" } },
                  [
                    _vm._v(
                      "บีนีทจะไม่รับผิดชอบต่อความสูญหายของทรัพย์สินของลูกค้าในทุกกรณี ท่านจะต้องรับผิดชอบในการเก็บรักษาทรัพย์สินของท่านด้วยตัวเองให้ดีทุกครั้งในขณะรับบริการ"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "my-2", attrs: { "aria-current": "list7_5" } },
                  [
                    _vm._v(
                      "หากพ้น 24 ชั่วโมง นับจากการให้บริการสิ้นสุดลงและผู้ให้บริการอิสระได้กดส่งงานมายังบีนีท หากท่านไม่ได้แจ้งความชำรุดบกพร่องของงานหรือความเสียหายต่อทรัพย์สินมายังบีนีท ท่านตกลงให้ถือว่างานบริการนั้นสิ้นสุดลงโดยไม่มีความชำรุดบกพร่องหรือความเสียหายแต่อย่างใด"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "my-2", attrs: { "aria-current": "list7_6" } },
                  [
                    _vm._v(
                      "ท่านรับทราบว่าตลอดการให้บริการ ท่านมีหน้าที่ดูแลรับผิดชอบผู้เยาว์ด้วยตัวท่านเอง ผู้ให้บริการอิสระจะไม่รับฝากหรือรับดูแลผู้เยาว์ไม่ว่ากรณีใดๆ เช่นเดียวกับกรณีของสัตว์เลี้ยง ท่านจะต้องจัดการให้สัตว์เลี้ยงอยู่ในกรง หรือ ที่เก็บสัตว์เลี้ยงอย่างปลอดภัยและไม่เป็นการรบกวนต่อการทำงานของผู้ให้บริการอิสระและท่านยอมรับว่าความสูญหายหรือความเสียหายใดๆ ที่เกี่ยวกับเด็ก ผู้เยาว์หรือสัตว์เลี้ยงของท่าน แม้จะเกิดขึ้นระหว่างช่วงเวลาทำงานของผู้ให้บริการอิสระ ถือว่าอยู่นอกขอบเขตการให้บริการและไม่อยู่ในความรับผิดชอบของบีนีท โดยท่านรับทราบและยินยอมจะปฏิบัติตามข้อตกลงและจะไม่กระทำการอันเป็นการเรียกร้องใด ๆ เกี่ยวกับผู้เยาว์หรือสัตว์เลี้ยงทั้งสิ้น"
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "font-weight-bold li__head__line" }, [
                _vm._v("วงเงินประกันการบริการ")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "บีนีทมีวงเงินประกันคุ้มครองความเสียหาย หากเกิดกรณีที่ผู้ให้บริการอิสระทำให้เกิดความเสียหาย ชำรุดบกพร่องต่อทรัพย์สินของลูกค้า ดังนี้"
                )
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "mar3rem" }, [
                _c("li", [
                  _vm._v(
                    "บริการทำความสะอาด วงเงินประกันสูงสุดไม่เกิน 100,000 บาท "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("บริการรีดผ้า วงเงินประกันสูงสุดไม่เกิน 1,000 บาท")
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "บริการกำจัดไรฝุ่น วงเงินประกันสูงสุดไม่เกิน 100,000 บาท"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "วงเงินประกันจะคุ้มครองความเสียหาย ชำรุดแตกหัก อันเกิดจากการให้บริการของบีนีท ยกเว้นความเสียหายที่เกิดกับทรัพย์สินที่มีมูลค่าสูงหรือทรัพย์สินที่ทำจากวัสดุซึ่งต้องใช้ความเชี่ยวชาญและความระมัดระวังเป็นพิเศษในการดูแลทำความสะอาดที่ท่านจะต้องแจ้งให้ผู้ให้บริการทราบเป็นลายลักษณ์อักษรก่อนการให้บริการแต่ท่านไม่ได้แจ้งให้ผู้ให้บริการรับทราบ ทั้งนี้วงเงินประกันจะไม่ครอบคลุมถึงความสูญหายของทรัพย์สินทุกชนิด "
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "บีนีทขอยืนยันว่าบีนีทไม่มีความรับผิดชอบใดๆต่อความความสูญหายหรือความเสียหายใดๆ เกี่ยวกับเด็ก ผู้เยาว์ สัตว์เลี้ยงที่อยู่ในความดูแลของท่านทุกกรณี และวงเงินประกันตามความในข้อนี้ไม่ครอบคลุมถึงกรณีที่บีนีทไม่ต้องรับผิดชอบในทุกกรณี"
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "font-weight-bold li__head__line" }, [
                _vm._v("การชำระค่าบริการ")
              ]),
              _vm._v(" "),
              _c("ol", { staticClass: "list9" }, [
                _c(
                  "li",
                  { staticClass: "my-2", attrs: { "aria-current": "list9_1" } },
                  [
                    _vm._v(
                      "ท่านตกลงจ่ายค่าบริการสำหรับงานบริการประเภทต่างๆ ตามอัตราที่ระบุไว้ ในขณะที่ทำการจองการบริการผ่านบีนีทแพลตฟอร์ม ซึ่งบีนีทแพลตฟอร์มอาจออกโปรโมชันหรือส่วนลดในเวลาใดๆ ก็ได้ ท่านทราบและเข้าใจดีว่าค่าบริการในแต่ละครั้งอาจแตกต่างกันขึ้นอยู่กับช่วงเวลาการจองและการจัดโปรโมชันของบีนีท  "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "my-2", attrs: { "aria-current": "list9_2" } },
                  [
                    _vm._v(
                      "ในกรณีที่ท่านต้องการให้ผู้ให้บริการอิสระปฏิบัติงานนอกเหนือจากที่ได้ตกลงไว้ตอนจองงานหรือตามที่ปรากฏในรายละเอียดของงาน (Work order) หรือในกรณีที่ผู้ให้บริการอิสระประเมินการทำงานหน้างานจริงแล้วเห็นว่าต้องใช้ชั่วโมงการทำงานเพิ่ม ท่านสามารถตกลงและเพิ่มจำนวนชั่วโมงการทำงานได้  ในกรณีดังกล่าวให้ท่านแจ้งกลับมายังบีนีทเพื่อตกลงจ้างบริการเพิ่มเติม (Additional Work) ตามชั่วโมงการทำงานที่เพิ่มขึ้นได้ และท่านตกลงชำระเงินค่าบริการงานเพิ่มทันทีที่ได้มีการเพิ่มชั่วโมงการทำงานกันเป็นที่เรียบร้อย โดยท่านสามารถเลือกวิธีการชำระเงินตามที่บีนีทแพลตฟอร์มกำหนด"
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "font-weight-bold li__head__line" }, [
                _vm._v("ช่องทางการติดต่อกับบีนีท ")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "ท่านสามารถติดต่อกับบีนีทหรือแจ้งปัญหาที่เกิดขึ้นจากการให้บริการของเรา หรือติดต่อผู้ดูแลระบบเพื่อประสานงานรวมทั้งเสนอแนะเรื่องต่างๆ ผ่านช่องทางดังต่อไปนี้"
                )
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "mar3rem" }, [
                _c("li", [_vm._v("ผ่านระบบการให้บริการของบีนีทแพลตฟอร์ม ")]),
                _vm._v(" "),
                _c("li", [_vm._v("ผ่านไลน์แอปพลิเคชัน ")]),
                _vm._v(" "),
                _c("li", [_vm._v("ผ่านการโทรศัพท์ เบอร์ติดต่อ 02-113 1138")]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "ผ่านไปรษณีย์ลงทะเบียน ที่อยู่  227/70  หมู่ที่ 7 ต.สันผีเสื้อ อ.เมืองเชียงใหม่ จ.เชียงใหม่ 50300"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "font-weight-bold li__head__line" }, [
                _vm._v("การปรับเปลี่ยน วันเวลา การให้บริการ ")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "ในกรณีที่ท่านต้องการปรับเปลี่ยนกำหนดเวลาการให้บริการ ให้ท่านแจ้งความประสงค์มายังบีนีทแพลตฟอร์ม ก่อนวันและกำหนดเวลาเดิมไม่น้อยกว่า 24 ชั่วโมง เพื่อกำหนดเวลาการให้บริการใหม่ กรณีที่ท่านแจ้งมาเกินกำหนดเวลาข้างต้น บีนีทอาจไม่สามารถปรับเปลี่ยนเวลาและผู้ให้บริการอิสระได้ตามความต้องการของท่าน แต่บีนีทจะดำเนินการเพื่อหาวันเวลาและผู้ให้บริการที่เหมาะสมเพื่อให้บริการตามกำหนดการให้บริการใหม่ต่อไป อย่างไรก็ตาม บีนีทไม่รับรองว่าจะสามารถปรับเปลี่ยนได้ตามวันและเวลาที่ท่านต้องการได้ ในกรณีดังกล่าวจะถือว่าท่านรับทราบถึงข้อจำกัดประการนี้แล้ว "
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "font-weight-bold li__head__line" }, [
                _vm._v("นโยบายการคืนเงินค่าบริการ")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "กรณีท่านขอเปลี่ยนแปลงกำหนดนัดหมายหรือแจ้งยกเลิกการจองหรือการรับบริการผ่านบีนีทแพลตฟอร์ม หรือมีการขอเปลี่ยนรายละเอียดงาน โดยที่ผู้ให้บริการอิสระไม่สามารถดำเนินการได้ บีนีทมีดุลยพินิจในการพิจารณาคืนเงินค่าบริการ ดังนี้"
                )
              ]),
              _vm._v(" "),
              _c("table", [
                _c("tr", [
                  _c("td", { staticClass: "td__width td__border" }, [
                    _vm._v(
                      "กรณีท่านแจ้งยกเลิกงาน หรือเปลี่ยนแปลงนัดหมายและ/หรือรายละเอียดงานโดยที่ผู้ให้บริการอิสระไม่สามารถดำเนินการได้มากกว่า 24 ชั่วโมงก่อนเวลาปฏิบัติงาน"
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "td__border" }, [
                    _vm._v("ท่านมีสิทธิได้รับค่าบริการคืน 96%")
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", { staticClass: "td__width td__border" }, [
                    _vm._v(
                      "กรณีท่านยกเลิกงาน หรือเปลี่ยนแปลงนัดหมายและ/หรือรายละเอียดงานโดยที่ให้ผู้บริการอิสระไม่สามารถดำเนินการได้น้อยกว่า 24 ชั่วโมง แต่ไม่ต่ำกว่า 2 ชั่วโมงก่อนเวลาปฏิบัติงาน"
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "td__border" }, [
                    _vm._v("ท่านมีสิทธิได้รับค่าบริการคืน 50%")
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", { staticClass: "td__width td__border" }, [
                    _vm._v(
                      "กรณีท่านยกเลิกงาน หรือเปลี่ยนแปลงนัดหมายและ/หรือรายละเอียดงานโดยที่ให้ผู้บริการอิสระไม่สามารถดำเนินการได้ต่ำกว่า 2 ชั่วโมงก่อนเวลาปฏิบัติงาน"
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "td__border" }, [
                    _vm._v("บีนีทสงวนสิทธิในการไม่คืนค่าบริการแก่ท่าน")
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "font-weight-bold li__head__line" }, [
                _vm._v("นโยบายการคุ้มครองข้อมูลส่วนบุคคล (PDPA)")
              ]),
              _vm._v(" "),
              _c("ol", { staticClass: "list13" }, [
                _c(
                  "li",
                  {
                    staticClass: "my-2",
                    attrs: { "aria-current": "list13_1" }
                  },
                  [
                    _vm._v(
                      "เพื่อวัตถุประสงค์ของข้อตกลงฉบับนี้ “ข้อมูลส่วนบุคคล” หมายถึง ข้อมูลที่เกี่ยวกับลูกค้าและผู้ให้บริการอิสระซึ่งสามารถระบุตัวตนได้ รวมถึงแต่ไม่จำกัดเฉพาะชื่อ หมายเลขบัตรประจำตัวประชาชน หมายเลขประจำตัวในใบสูติบัตร เลขหนังสือเดินทาง สัญชาติ ที่อยู่ หมายเลขโทรศัพท์ บัญชีธนาคาร ประวัติสุขภาพ รายละเอียดบัตรเครดิตหรือบัตรเดบิต เชื้อชาติ เพศ วันเกิด ที่อยู่ทางไปรษณีย์อิเล็กทรอนิกส์ ข้อมูลใดๆ ที่ลูกค้า หรือ ผู้ให้บริการอิสระซึ่งผู้ให้บริการอิสระได้ให้ไว้แก่บีนีทไม่ว่าในทางใด และ/หรือข้อมูลใดๆ เกี่ยวกับลูกค้า หรือผู้ให้บริการอิสระซึ่งบีนีทได้รวบรวม เก็บรักษา ใช้ และดำเนินการประมวลผลใดๆ บีนีทยังอาจรวบรวมข้อมูลโทรสนเทศ (telematics data) (เช่น ความเร็ว อัตราและข้อมูลการเบรกของผู้ให้บริการอิสระ) ข้อมูลอุปกรณ์ (เช่น เลข IMEI ของลูกค้าและชื่อของแพลตฟอร์มอื่นๆ ที่ลูกค้าได้ติดตั้งลงในอุปกรณ์ของลูกค้า) และข้อมูลทะเบียนยานพาหนะของผู้ให้บริการอิสระ เป็นต้น"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "my-2",
                    attrs: { "aria-current": "list13_2" }
                  },
                  [
                    _vm._v(
                      "การให้ข้อมูลส่วนบุคคลของท่านนั้นเป็นไปโดยสมัครใจ อย่างไรก็ดี หากท่านไม่ให้ข้อมูลส่วนบุคคลใดๆ ของท่านแก่บีนีท คำร้องขอของท่านเพื่อใช้บริการแพลตฟอร์มอาจจะไม่สมบูรณ์ เนื่องจากบีนีทอาจจะไม่สามารถดำเนินการประมวลผลข้อมูลส่วนบุคคลของท่านได้เพื่อวัตถุประสงค์ตามที่ระบุไว้ด้านล่างและอาจทำให้บีนีทไม่สามารถอนุญาตให้ท่านใช้บริการของบีนีทได้"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "my-2",
                    attrs: { "aria-current": "list13_3" }
                  },
                  [
                    _vm._v(
                      "บีนีทอาจใช้และประมวลผลข้อมูลส่วนบุคคลของท่านเพื่อธุรกิจและกิจกรรมของบีนีท ซึ่งรวมถึงแต่ไม่จำกัดเฉพาะกรณีดังต่อไปนี้ (“วัตถุประสงค์”) ทั้งนี้ ท่านตกลงและให้ความยินยอมแก่บีนีทในการใช้และประมวลผลข้อมูลส่วนบุคคลของท่านเพื่อวัตถุประสงค์และเพื่อการดำเนินการตามที่ระบุด้านล่างนี้\n                    "
                    ),
                    _c("ul", { staticClass: "mar3rem" }, [
                      _c("li", [
                        _vm._v(
                          "เพื่อปฏิบัติหน้าที่ของบีนีทตามที่ระบุในสัญญาใดๆ ที่บีนีทได้ทำกับท่าน "
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "เพื่อให้บริการใดๆ แก่ท่านตามเงื่อนไขในการใช้บริการ "
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "เพื่อทำให้การชำระเงินสมบูรณ์ และ/หรือดำเนินการชำระเงินให้เป็นไปตามเงื่อนไขในการใช้บริการ "
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "เพื่อดำเนินการคืนเงิน รับส่วนลด และเรียกเก็บค่าบริการใดๆ ตามที่กำหนดในเงื่อนไขในการใช้บริการ "
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "เพื่ออำนวยความสะดวกหรือทำให้สามารถดำเนินการตรวจสอบใดๆ ได้ตามที่กำหนดไว้ในเงื่อนไขในการใช้บริการ "
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "เพื่อการพัฒนา เพิ่มประสิทธิภาพ และจัดให้มีสิ่งใดๆ ก็ตามที่กำหนดในเงื่อนไขในการใช้บริการเพื่อตอบสนองความต้องการของท่าน "
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "เพื่อวัตถุประสงค์ในการบริหารการจัดการภายใน เช่น การตรวจสอบ การวิเคราะห์ข้อมูล การบันทึกฐานข้อมูล "
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "เพื่อวัตถุประสงค์ในการสืบค้น การป้องกัน และการฟ้องคดีอาญา รวมถึงที่เกี่ยวข้องกับหน้าที่ของบีนีทภายใต้กฎหมายใดๆ ที่บังคับใช้ ระเบียบ แนวทาง หรือคำสั่งที่ออกโดยรัฐบาลหรือหน่วยงานราชการใดๆ (ไม่ว่าจะในประเทศไทยหรือต่างประเทศ) "
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v("เพื่อตอบคำถาม ความเห็นและข้อเสนอแนะจากท่าน ")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "ทั้งนี้ การใช้ข้อมูลส่วนบุคคลของบีนีทจะเป็นไปตามกฎหมายที่บังคับใช้และอนุญาตให้ใช้ จัดเก็บ เปิดเผย \tและประมวลผลข้อมูลส่วนบุคคลเท่านั้น"
                      )
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "my-2", attrs: { "aria-current": "list13_4" } },
                [
                  _vm._v(
                    "นอกเหนือจากวัตถุประสงค์ข้างต้น บีนีทอาจประสงค์จะติดต่อท่านผ่านอีเมล์ โทรศัพท์ หรือข้อความเกี่ยวกับ\tเรื่องดังต่อไปนี้ (“วัตถุประสงค์ด้านการตลาด”) ตามที่ระบุด้านล่างนี้\n                "
                  ),
                  _c("ul", { staticClass: "mar3rem" }, [
                    _c("li", [
                      _vm._v(
                        "เพื่อประมวลผลการมีส่วนร่วมในงาน กิจกรรมส่งเสริมการขาย ฝึกอบรม การศึกษางานวิจัย การประกวด โพล การทำสำรวจ หรือการผลิตงานใดๆ และเพื่อติดต่อสื่อสารกับท่านในการร่วมงานดังกล่าว"
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v(
                        "เพื่อส่งข้อความเตือน จดหมายข่าว ข้อมูลที่เป็นปัจจุบัน จดหมายทางไปรษณีย์ เอกสารที่เกี่ยวกับการส่งเสริมการขาย สิทธิพิเศษ ข้อความตามเทศกาลต่างๆ จากบีนีท คู่ค้า ผู้จัดทำโฆษณา และ/หรือผู้สนับสนุน"
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v(
                        "เพื่อเปิดเผยข้อมูลส่วนบุคคลของท่านระหว่างภายในกลุ่มของบีนีท ที่ประกอบด้วย บีนีท บริษัทในเครือบีนีทและ/หรือบริษัทที่ควบคุมร่วมกันของบีนีท (“กลุ่มบีนีท”) กับตัวแทน ของบีนีท และตัวแทนของกลุ่มบีนีท ผู้จัดทำซึ่งเป็นบุคคลภายนอก ผู้พัฒนา ผู้จัดทำโฆษณา คู่ค้า บริษัทที่จัดงาน หรือผู้สนับสนุนของกลุ่มบีนีทผู้ซึ่งอาจติดต่อสื่อสารกับท่านไม่ว่าด้วยเหตุผลประการใดก็ตาม"
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "my-2", attrs: { "aria-current": "list13_5" } },
                [
                  _vm._v(
                    "หากท่านไม่ได้ให้ความยินยอมแก่บีนีทในการประมวลผลข้อมูลส่วนบุคคลของผู้ให้บริการอิสระไม่ว่าเพื่อวัตถุประสงค์ด้านการตลาดข้อใดก็ตาม กรุณาแจ้งให้บีนีททราบโดยใช้รายละเอียดของการติดต่อตามที่ระบุในแพลตฟอร์ม"
                  )
                ]
              ),
              _vm._v(" "),
              _c("li", { staticClass: "font-weight-bold li__head__line" }, [
                _vm._v("คำรับรองและข้อผูกพัน")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "ในการใช้บริการหรือแพลตฟอร์ม ท่านในฐานะลูกค้าได้รับรองและผูกพันว่าท่านมีความสามารถตามกฎหมายในการเข้าทำข้อตกลงนี้ ดังนี้"
                )
              ]),
              _vm._v(" "),
              _c("ol", { staticClass: "list14" }, [
                _c(
                  "li",
                  {
                    staticClass: "my-2",
                    attrs: { "aria-current": "list14_1" }
                  },
                  [
                    _vm._v(
                      "ข้อมูลที่ท่านได้ให้ไว้กับบีนีทตามเพื่อใช้บริการบีนีทแพลตฟอร์มนั้น มีความถูกต้องแม่นยำ ไม่ทำให้เข้าใจผิด \tเป็นปัจจุบันและสมบูรณ์ โดยท่านมีหน้าที่รับผิดชอบในการรักษาข้อมูลและทำให้ข้อมูลเป็นปัจจุบันอยู่เสมอและแจ้งให้บีนีททราบภายในเวลาอันสมควร หากมีการเปลี่ยนแปลง บีนีทจะยึดถือว่าข้อมูลที่ท่านให้เป็นข้อมูลที่ถูกต้องสมบูรณ์ อย่างไรก็ตาม หากบีนีทพบว่าข้อมูลของท่านนั้นไม่ถูกต้อง ไม่แม่นยำ ทำให้เข้าใจผิดไม่เป็นปัจจุบัน และไม่สมบูรณ์ไม่ว่าทางใดทางหนึ่งก็ตาม บีนีทมีสิทธิบอกเลิกข้อตกลงและการใช้บริการของท่านได้ตลอดเวลาโดยไม่ต้องมีการบอกกล่าวแต่อย่างใด"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "my-2",
                    attrs: { "aria-current": "list14_2" }
                  },
                  [
                    _vm._v(
                      "ท่านตกลงจะให้ข้อมูลใดๆ ก็ตาม ไม่ว่าจะเป็น เอกสาร ใบอนุญาต การอนุญาต หรือการอนุมัติที่บีนีทร้องขอหรือต้องจัดให้มีตามความเหมาะสมเพื่อพิสูจน์ตัวตนของท่าน"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "my-2",
                    attrs: { "aria-current": "list14_3" }
                  },
                  [
                    _vm._v(
                      "ท่านจะต้องเก็บรหัสผ่านบัญชีหรือข้อมูลยืนยันตัวตนที่สามารถใช้เข้าถึงบริการของบีนีทแพลตฟอร์มไว้อย่างปลอดภัยและเป็นความลับ"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "my-2",
                    attrs: { "aria-current": "list14_4" }
                  },
                  [
                    _vm._v(
                      "ท่านจะต้องไม่อนุญาตให้ผู้อื่นใช้ข้อมูลยืนยันตัวตน หรือสถานะท่านของท่าน และท่านจะต้องไม่มอบหมายหรือโอนบัญชีผู้ใช้ให้กับผู้อื่นหรือนิติบุคคลอื่น"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "my-2",
                    attrs: { "aria-current": "list14_5" }
                  },
                  [
                    _vm._v(
                      "ท่านตกลงที่จะแจ้งให้บีนีททราบทันทีเมื่อมีการใช้บัญชีของท่านโดยไม่ได้รับอนุญาตหรือมีการละเมิดความปลอดภัยเกิดขึ้น"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "my-2",
                    attrs: { "aria-current": "list14_6" }
                  },
                  [
                    _vm._v(
                      "ท่านจะต้องใช้บีนีทแพลตฟอร์มหรือใช้บริการเพื่อตัวท่านเองและเพื่อวัตถุประสงค์ที่ถูกกฎหมายเท่านั้น ท่านจะต้องไม่ใช้บีนีทแพลตฟอร์มในการเก็บหรือส่งสิ่งใดก็ตามที่ผิดกฎหมายหรือใช้ในการหลอกลวงผู้อื่นหรือประชาชน"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "my-2",
                    attrs: { "aria-current": "list14_7" }
                  },
                  [
                    _vm._v(
                      "ท่านจะต้องไม่พยายามรบกวนการทำงานของการบริการ และ/หรือการทำงานของแพลตฟอร์ม หรือทำให้บริการและ/หรือแพลตฟอร์มของบีนีททำงานได้บกพร่อง หรือทำให้เกิดความเสียหายต่อบริการ และ/หรือแพลตฟอร์มไม่ว่าทางใดทางหนึ่ง และจะไม่กระทำการต่าง ๆ ดังต่อไปนี้ (ก) การส่งสแปมหรือส่งข้อความซ้ำๆ หรือข้อความอันไม่พึงประสงค์ (ข) การส่งหรือจัดเก็บเนื้อหาที่เป็นการละเมิด ลามกอนาจาร ข่มขู่ ใส่ร้าย หรือเนื้อหาอื่นใดที่ผิดกฎหมายหรือเป็นการละเมิด รวมถึงแต่ไม่จำกัดเฉพาะสื่อที่เป็นอันตรายต่อเด็กหรือละเมิดสิทธิความเป็นส่วนตัวของบุคคลที่สาม (ค) การส่งสื่อที่มีซอฟต์แวร์ไวรัส เวิร์ม ม้าโทรจัน หรือรหัสคอมพิวเตอร์ ไฟล์ สคริปต์ ตัวแทน หรือโปรแกรมอื่นๆ ที่เป็นอันตราย (ง) แทรกแซงหรือขัดขวางความสมบูรณ์หรือประสิทธิภาพของแพลตฟอร์มหรือข้อมูลที่อยู่ในนั้น (จ) พยายามเข้าถึงแพลตฟอร์มหรือซอฟต์แวร์ ระบบ หรือเครือข่ายที่เกี่ยวข้องโดยไม่ได้รับอนุญาต (ฉ) การแอบอ้างเป็นบุคคลหรือนิติบุคคลใดๆ หรือบิดเบือนความจริงว่าท่านมีส่วนเกี่ยวข้องกับบุคคลหรือนิติบุคคลใดๆ (ช) มีส่วนร่วมในการกระทำใดๆ ที่อาจสร้างความเสียหายต่อชื่อเสียงของบีนีทหรือที่อาจส่งผลให้เกิดความไม่น่าไว้วางใจต่อบีนีท (ซ) การหลีกเลี่ยงการใช้งานที่เหมาะสมของแพลตฟอร์มและเครือข่ายที่บริการดำเนินการอยู่ และ (ฌ) การใช้โปรแกรมหรือสคริปต์แบบแมนนวลหรือแบบอัตโนมัติ ซึ่งรวมถึงแต่ไม่จำกัดเพียงสไปเดอร์เว็บ โปรแกรมรวบรวมข้อมูลเว็บ เว็บหุ่นยนต์ Web ants ตัวทำดัชนีเว็บ บอต ไวรัสหรือเวิร์ม หรือโปรแกรมใดๆ ที่อาจเป็นภาระหรือขัดขวางการดำเนินการ และ/หรือประสิทธิภาพของบีนีทแพลตฟอร์ม"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "my-2",
                    attrs: { "aria-current": "list14_8" }
                  },
                  [
                    _vm._v(
                      "ท่านจะต้องไม่ใช้ประโยชน์จากอุปกรณ์หรือแอปพลิเคชันที่มีการดัดแปลง ด้วยวัตถุประสงค์ในการหลบเลี่ยงการตรวจจับหรือเพื่ออำนวยความสะดวกการกระทำใดๆ ที่มุ่งหมายเพื่อกระทำการทุจริตต่อบีนีท หรือเพื่อ รบกวนฟังก์ชันการใช้งานของแพลตฟอร์ม"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "my-2",
                    attrs: { "aria-current": "list14_9" }
                  },
                  [
                    _vm._v(
                      "ท่านจะไม่ใช้แพลตฟอร์มในการส่งหรือจัดเก็บสิ่งใดๆ ที่ผิดกฎหมายหรือเพื่อวัตถุประสงค์ในการหลอกลวง"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "my-2",
                    attrs: { "aria-current": "list14_10" }
                  },
                  [
                    _vm._v(
                      "ท่านจะต้องไม่ใช้แพลตฟอร์มในการสร้างความเดือดร้อนรำคาญหรือกระทำการอันไม่เหมาะสมหรือไม่ให้ความเคารพต่อบีนีทหรือบุคคลภายนอก"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "my-2",
                    attrs: { "aria-current": "list14_11" }
                  },
                  [
                    _vm._v(
                      "ท่านยินยอมที่จะสนับสนุนบีนีทในการสืบสวนทั้งภายในและภายนอกที่อาจจะถูกร้องขอโดยบีนีทตาม\tกฎหมายที่บังคับใช้หรือ ข้อบังคับต่างๆ"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "my-2",
                    attrs: { "aria-current": "list14_12" }
                  },
                  [
                    _vm._v(
                      "ท่านจะให้เบอร์โทรศัพท์และข้อมูลการติดต่ออื่นๆ ที่อยู่ในโทรศัพท์มือถือของท่าน ท่านยืนยันว่าท่านมีสิทธิที่จะให้ข้อมูลดังกล่าวกับบีนีทเพื่อนำไปพัฒนาบริการและบีนีทแพลตฟอร์มให้กับท่านหรือเพื่อวัตถุประสงค์อื่นใดที่บีนีทอาจแจ้งให้ท่านทราบก่อนหรือในขณะที่จะมีการใช้ข้อมูลนั้น"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "my-2",
                    attrs: { "aria-current": "list14_13" }
                  },
                  [
                    _vm._v(
                      "ท่านทราบว่าในการใช้บริการหรือการเข้าถึงแพลตฟอร์ม หากมีการเรียกใช้บริการผ่าน SMS หรือบริการเครือข่ายโทรศัพท์ ท่านจะต้องรับผิดชอบค่าใช้จ่ายบริการเครือข่ายโทรศัพท์ รวมทั้งค่าบริการต่างๆ เกี่ยวกับอุปกรณ์มือถือด้วยตัวท่านเอง"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "my-2",
                    attrs: { "aria-current": "list14_14" }
                  },
                  [
                    _vm._v(
                      "\tท่านจะใช้บริการและแพลตฟอร์มเพื่อการใช้งานส่วนบุคคล หรือใช้ตามขอบเขตที่ได้รับอนุญาต หากเป็นกรณีที่ท่านใช้งานเพื่อบุคคลที่มีอายุต่ำกว่ายี่สิบปีบริบูรณ์ (“ผู้เยาว์”) ท่านจะต้องรับผิดชอบการใช้งานของผู้เยาว์นั้นด้วย"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "my-2",
                    attrs: { "aria-current": "list14_15" }
                  },
                  [
                    _vm._v(
                      "ท่านจะไม่ติดต่อผู้ให้บริการอิสระเพื่อวัตถุประสงค์อื่น นอกเหนือจากการติดต่อที่เกี่ยวกับการบริการของบีนีทเท่านั้น"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "my-2",
                    attrs: { "aria-current": "list14_16" }
                  },
                  [
                    _vm._v(
                      "ท่านจะต้องไม่สร้างความเสียหายหรือพยายามสร้างความเสียหายต่อผู้ให้บริการอิสระหรือต่อทรัพย์สินของผู้ให้บริการอิสระ ไม่ว่าจะโดยเจตนาหรือไม่เจตนาก็ตาม"
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "font-weight-bold li__head__line" }, [
                _vm._v("การให้คะแนน")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "ท่านอาจจะได้รับการอนุญาตให้ประเมินการให้บริการของผู้ให้บริการอิสระ การประเมินแต่ละครั้งจะถูกบันทึกลงในระบบของบีนีทโดยอัตโนมัติและบีนีทจะวิเคราะห์การประเมินที่ได้รับทั้งหมด ทั้งนี้ บีนีทอาจกระทำการใดๆ เกี่ยวกับข้อมูลการให้คะแนนและการให้ความคิดเห็นของท่านตามที่บีนีทเห็นสมควรซึ่งรวมถึงการระงับการใช้บริการของท่านโดยไม่บอกล่วงหน้า"
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "font-weight-bold li__head__line" }, [
                _vm._v("ความเป็นเจ้าของทรัพย์สินทางปัญญา")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "บีนีทถือความเป็นเจ้าของในสิทธิ กรรมสิทธิ์และผลประโยชน์ รวมถึงทรัพย์สินทางปัญญาที่เกี่ยวข้องทั้งหมดของบีนีทแพลตฟอร์ม รวมถึงวิธีการให้บริการและคำแนะนำอื่นๆ คำร้องขอให้ปรับปรุง ข้อเสนอแนะข้อแนะนำหรือข้อมูลอื่นๆที่ท่านหรือฝ่ายอื่นใดก็ตามที่มีส่วนเกี่ยวข้องกับการบริการ และ/หรือบีนีทแพลตฟอร์มเป็นผู้ให้ไว้ ข้อตกลงการให้บริการนั้น ไม่ถือเป็นสัญญาซื้อขายและจะไม่ถ่ายโอนสิทธิในความเป็นเจ้าของใดๆ อันเกี่ยวกับบริการ และ/หรือแพลตฟอร์ม หรือทรัพย์สินทางปัญญาอื่นใดที่บีนีทหรือผู้อนุญาตเป็นเจ้าของ ชื่อของบีนีท โลโก้และเครื่องหมายการค้าของบีนีท บริการ แพลตฟอร์ม เครื่องหมายการค้าของผู้ให้บริการขนส่งบุคคลที่สาม และชื่อผลิตภัณฑ์ที่เกี่ยวข้องกับซอฟต์แวร์ แพลตฟอร์ม เครื่องหมายการค้าของบีนีท  และจะไม่มีการให้สิทธิหรือให้อนุญาตในการใช้สิ่งเหล่านี้ ทั้งนี้ เพื่อให้ปราศจากความสงสัยคำว่า “บีนีทแพลตฟอร์ม” ให้หมายรวมถึง ส่วนประกอบ กระบวนการทำ ลักษณะดีไซน์ ข้อความใดๆ ที่ปรากฏขึ้นหรือประกอบขึ้นเป็นบีนีทแพลตฟอร์มด้วย"
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "font-weight-bold li__head__line" }, [
                _vm._v("ภาษีและค่าอากรแสตมป์")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "บีนีทจะเป็นผู้รับผิดชอบภาษีใดๆ อันเกิดจากรายได้ที่บีนีทได้รับจากการให้บริการของบีนีท และให้หมายรวมถึงค่าอากรแสตมป์บีนีทจะเป็นผู้รับผิดชอบและชำระต่อหน่วยงานราชการที่เกี่ยวข้องด้วย ในกรณีที่ท่านหักภาษี ณ ที่จ่ายให้แก่บีนีท ให้ท่านนำส่งใบกำกับภาษีมายังที่อยู่ของบีนีทที่ได้ให้ไว้กับท่าน ทั้งนี้ หากท่านต้องการรับเสร็จรับเงิน ท่านจะต้องให้ข้อมูลเลขที่ผู้เสียภาษีของท่านและข้อมูลอื่นๆ ที่จำเป็นต่อการออกใบเสร็จรับเงินตามที่บีนีทขอจากท่านให้อย่างครบถ้วน"
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "font-weight-bold li__head__line" }, [
                _vm._v(
                  "การปฏิสัมพันธ์ระหว่างลูกค้ากับผู้ให้บริการอิสระและกับบุคคลที่สาม"
                )
              ]),
              _vm._v(" "),
              _c("ol", { staticClass: "list18" }, [
                _c(
                  "li",
                  {
                    staticClass: "my-2",
                    attrs: { "aria-current": "list18_1" }
                  },
                  [
                    _vm._v(
                      "บีนีทอาจต้องให้ลูกค้ามีการติดต่อและ/หรือมีปฏิสัมพันธ์โดยตรงกับผู้ให้บริการอิสระในการรับบริการ ทั้งนี้บีนีทขอให้ท่านระมัดระวังในการใช้คำเพื่อการติดต่อสื่อสารที่อาจก่อให้เกิดการละเมิด ดูหมิ่น ความก้าวล่วงทางเพศ บีนีทไม่แนะให้ท่านติดต่อผู้ให้บริการอิสระของเราในเรื่องอื่นใดนอกเหนือจากการให้บริการ และบีนีทจะไม่รับผิดชอบหากเกิดกรณีพิพาทกันระหว่างลูกค้าและผู้ให้บริการอิสระที่ไม่เกี่ยวกับงานบริการ "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "my-2",
                    attrs: { "aria-current": "list18_2" }
                  },
                  [
                    _vm._v(
                      "บีนีทอาจต้องใช้บริการบุคคลที่สามในทำการโฆษณาและการตลาดผ่านบริการ และวิธีการต่างๆ ที่จะช่วยเหลือการบริการและ/หรือสร้างรายได้เพิ่มเติม หากท่านไม่ต้องการรับการสื่อสารทางการโฆษณาหรือการตลาด โปรดศึกษานโยบายความเป็นส่วนตัวในข้อ 13 ของข้อตกลงนี้ สำหรับข้อแนะนำเพื่อเลิกติดตามการสื่อสารดังกล่าว หรือเพื่ออัพเดทการตั้งค่าความเป็นส่วนตัวของท่าน"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "my-2",
                    attrs: { "aria-current": "list18_3" }
                  },
                  [
                    _vm._v(
                      "บีนีทอาจจะใช้ไฮเปอร์ลิงก์ไปยังเว็บไซต์หรือเนื้อหาอื่นบนอินเทอร์เน็ตที่บุคคลที่สามเป็นเจ้าของหรือดำเนินการ เว็บไซต์หรือเนื้อหาที่เชื่อมโยงดังกล่าวไม่ได้อยู่ภายใต้การควบคุมของบีนีท และบีนีทจะไม่รับผิดชอบต่อข้อผิดพลาด การละเลย ความล่าช้า การหมิ่นประมาท การกล่าวโทษ การใส่ร้าย ความเท็จ ภาพลามกอนาจาร ความหยาบคาย ความไม่ถูกต้อง หรือเนื้อหาที่น่ารังเกียจอื่นใดที่มีอยู่ในเนื้อหาหรือ ผลที่ตามมาของการเข้าถึงเว็บไซต์ที่เชื่อมโยงโดยไฮเปอร์ลิงก์ใดๆ ไปยังเว็บไซต์หรือเนื้อหาอื่นๆ ไม่ได้เป็นการรับรองหรือตรวจสอบเว็บไซต์หรือเนื้อหาดังกล่าว และท่านยอมรับว่าการเข้าถึงหรือการใช้เว็บไซต์หรือเนื้อหาที่เชื่อมโยงนั้นเป็นความเสี่ยงของท่านเอง"
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "font-weight-bold li__head__line" }, [
                _vm._v("การปฏิเสธการรับรองการทำงานของบีนีทแพลตฟอร์ม")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "บีนีทขอแจ้งว่าบีนีทจะไม่รับรองหรือการันตีถึงความน่าเชื่อถือ ความตรงต่อเวลา คุณภาพ ความพร้อมใช้งาน ความแม่นยำหรือความสมบูรณ์ของการใช้งานบริการ, ซอฟต์แวร์, แอปพลิเคชันของบีนีทแพลตฟอร์ม บีนีทไม่สามารถรับประกันว่าการใช้งานบริการ ซอฟต์แวร์ แอปพลิเคชันของบีนีทแพลตฟอร์ม จะมีความปลอดภัย ไม่หยุดชะงัก ปราศจากข้อผิดพลาดหรือปราศจากเนื้อหาที่อันตราย หรือสามารถทำงานร่วมกันกับฮาร์ดแวร์ ซอฟต์แวร์ ระบบหรือข้อมูลอื่นใดได้อย่างไม่ติดขัด รวมถึงการตอบสนองความต้องการและความคาดหวังของท่าน บีนีทไม่สามารถรับรองความถูกต้องของข้อมูลที่ถูกเก็บไว้ว่าจะมีความเชื่อถือได้และเป็นปัจจุบันตลอดเวลา การใช้บีนีทแพลตฟอร์มจะเป็นไปตามสภาพและปัจจัยต่างๆ โดยรอบซึ่งบีนีทไม่อาจควบคุมได้ ทั้งนี้ การบริการบีนีทแพลตฟอร์มและ/หรือซอฟต์แวร์อาจอยู่ภายใต้ข้อจำกัด ความล่าช้า และปัญหาอื่นๆ ที่อาจเกิดขึ้นในการใช้อินเทอร์เน็ตและการสื่อสารทางอิเล็กทรอนิกส์ซึ่งรวมถึงอุปกรณ์อิเล็กทรอนิกส์ที่ท่านหรือผู้ให้บริการอิสระใช้เกิดความผิดพลาด ไม่สามารถเชื่อมต่อได้ อยู่นอกเครือข่าย ปิดเครื่องหรือไม่สามารถใช้งานได้ บีนีทจะไม่รับผิดชอบในความล่าช้า ความผิดพลาดในการขนส่ง ความเสียหายหรือความสูญหายที่เกิดจากปัญหาเหล่านี้"
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "font-weight-bold li__head__line" }, [
                _vm._v("เหตุสุดวิสัย")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "บีนีทปฏิเสธความรับผิดใดๆ ที่เกิดขึ้นจากความล่าช้าหรือการที่มิได้ปฏิบัติตามข้อตกลงนี้ อันเป็นผลมาจากเหตุที่เกิดขึ้น หรือเหตุการณ์ใดที่ไม่อาจจะหลีกเลี่ยงได้ตามสมควร ซึ่งรวมถึงโดยไม่จำกัดเฉพาะอุบัติเหตุ การกระทำของธรรมชาติ การก่อความวุ่นวายทางการเมือง โรคระบาด การระเบิด อัคคีภัย อุทกภัย การกบฏ การนัดหยุดงาน การปิดงาน มหันตภัยธรรมชาติ การจลาจล การไม่สามารถจัดหา หรือการขาดแคลนวัสดุอุปกรณ์ หรือการขนส่ง สงคราม หากฝ่ายที่ตกเป็นฝ่ายผิดนัดแจ้งให้อีกฝ่ายหนึ่งทราบทันที และใช้ความพยายามตามสมควรเพื่อขจัดผลของเหตุที่เกิดขึ้นหรือเหตุการณ์ดังกล่าว"
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "font-weight-bold li__head__line" }, [
                _vm._v("การระงับและการสิ้นสุด การปรับเปลี่ยนเนื้อหาแพลตฟอร์ม")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "ท่านตกลงว่าบีนีทอาจดำเนินการใดๆ ต่อไปนี้เมื่อใดก็ได้โดยไม่ต้องแจ้งให้ทราบ"
                )
              ]),
              _vm._v(" "),
              _c("ol", { staticClass: "list21" }, [
                _c(
                  "li",
                  {
                    staticClass: "my-2",
                    attrs: { "aria-current": "list21_1" }
                  },
                  [
                    _vm._v(
                      "บีนีทอาจเปลี่ยนแปลง แก้ไข ระงับหรือยุติการดำเนินการหรือการเข้าถึงแพลตฟอร์ม หรือส่วนใดส่วนหนึ่งของบีนีทแพลตฟอร์ม (รวมถึงการเข้าถึงบัญชีของท่านและ/หรือความพร้อมใช้งานของผลิตภัณฑ์หรือบริการใดๆ) ไม่ว่าจะด้วยเหตุผลใดก็ตาม"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "my-2",
                    attrs: { "aria-current": "list21_2" }
                  },
                  [
                    _vm._v(
                      "บีนีทอาจระงับการทำงานของบีนีทแพลตฟอร์มหรือส่วนใดส่วนหนึ่งของบีนีทแพลตฟอร์ม (รวมถึงการเข้าถึงบัญชีของท่านและ/หรือความพร้อมใช้งานของผลิตภัณฑ์หรือบริการใดๆ) ตามความจำเป็นในการดำเนินการบำรุงรักษาซึ่งอาจเป็นกิจวัตรประจำหรือไม่เป็นกิจวัตรประจำ การแก้ไขข้อผิดพลาด หรือการเปลี่ยนแปลงใดๆ บีนีทไม่จำเป็นต้องชดเชยให้ท่านสำหรับการปรับเปลี่ยน การระงับ หรือการยกเลิกใดๆ ดังที่กล่าวมานี้"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "my-2",
                    attrs: { "aria-current": "list21_3" }
                  },
                  [
                    _vm._v(
                      "บีนีทอาจแต่ไม่จำเป็นต้อง ตรวจสอบเนื้อหาหรือข้อมูลที่ส่งหรือแก้ไขโดยท่าน (ผ่านทางบีนีทแพลตฟอร์มหรือช่องทางอื่นๆ) เป็นครั้งคราว และบีนีทสงวนสิทธิในการลบหรือกำหนดให้มีการแก้ไขส่วนใดส่วนหนึ่งของเนื้อหาหรือข้อมูลที่ส่งโดยท่านในที่ซึ่งบีนีทเห็นว่าจำเป็น เพื่อให้ปราศจากข้อสงสัย ท่านจะต้องตรวจสอบให้แน่ใจเสมอว่าเนื้อหาหรือข้อมูลที่ส่งมานั้นไม่ขัดต่อกฎหมายที่บังคับใช้และไม่ละเมิดสิทธิ์ของบุคคลที่สาม ในกรณีที่ท่านแก้ไขเนื้อหาใดๆ ที่ส่งโดยท่าน ท่านตกลงเพิ่มเติมว่าการแก้ไขเนื้อหาดังกล่าว (1) ท่านได้รับความยินยอมหรือการยอมรับจากท่านที่ได้รับผลกระทบแล้ว และ (2) บีนีทไม่มีส่วนเกี่ยวข้องและจะไม่รับผิดชอบต่อการแก้ไขที่ทำขึ้นโดยท่าน ทั้งนี้ บีนีทขอสงวนสิทธิในการดำเนินมาตรการแก้ไขเพื่อทำให้การแก้ไขนั้นถูกต้องหรือระงับข้อพิพาทหรือข้อร้องเรียนที่เกิดขึ้นจากหรือเกี่ยวข้องกับการแก้ไขที่ทำขึ้น"
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "font-weight-bold li__head__line" }, [
                _vm._v("การระงับข้อพิพาท")
              ]),
              _vm._v(" "),
              _c("ol", { staticClass: "list22" }, [
                _c(
                  "li",
                  {
                    staticClass: "my-2",
                    attrs: { "aria-current": "list22_1" }
                  },
                  [
                    _vm._v(
                      "ในกรณีที่มีข้อพิพาทเกิดขึ้นระหว่างบีนีทกับลูกค้า ทั้งสองฝ่ายจะร่วมกันเจรจาอย่างมิตรภาพ เพื่อระงับข้อพิพาทได้เร็วขึ้นและลดค่าใช้จ่ายอันเกิดจากกรณีพิพาท ข้อโต้แย้งหรือข้อเรียกร้องเกี่ยวเนื่องข้อตกลงนี้ หรือประการอื่น ซึ่งเกิดจากสัมพันธภาพระหว่างลูกค้ากับบีนีท อย่างน้อยเป็นเวลา 30 (สามสิบ) วันก่อนนำไปสู่กระบวนการอนุญาโตตุลาการหรือขึ้นสู่ศาล การเจรจาดังกล่าวจะเริ่มดำเนินการเมื่อฝ่ายใดฝ่ายหนึ่งได้มีการแจ้งเป็นลายลักษณ์อักษรไปยังอีกฝ่ายหนึ่งตามที่อยู่ที่ให้ไว้กับบีนีทแพลตฟอร์ม"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "my-2",
                    attrs: { "aria-current": "list22_2" }
                  },
                  [
                    _vm._v(
                      "การดำเนินการเพื่อระงับข้อพิพาท เพื่อยุติข้อขัดแย้ง ข้อพิพาท หรือปัญหาระหว่างบีนีทและลูกค้า ปัญหาใดระหว่างทั้งสองฝ่ายที่ไม่เข้าในกรณีที่ไม่สามารถเจรจากันได้ตามข้อ 22.1 ให้ดำเนินการเสนอเรื่องสู่กระบวนการอนุญาโตตุลาการหรือขึ้นสู่ศาล เพื่อระงับข้อพิพาทนั้นต่อศาลของประเทศไทยที่มีเขตอำนาจต่อไป"
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "font-weight-bold li__head__line" }, [
                _vm._v("กฎหมายและเขตอำนาจ")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "ข้อตกลงนี้ให้อยู่ใต้บังคับของกฎหมายของประเทศไทย ให้ศาลของประเทศไทยมีอำนาจแต่ผู้เดียวในกรณีที่มีข้อพิพาทใดๆ เกิดขึ้นจากข้อตกลงนี้ ทั้งนี้ เงื่อนไขใดในข้อตกลงถือเป็นโมฆะ ไม่ชอบด้วยกฎหมายหรือใช้บังคับไม่ได้ในเขตท้องที่ใด ให้ถือเป็นโมฆะเฉพาะส่วนนั้น ส่วนข้อกำหนดหรือเงื่อนไขอื่นยังมีผลบังคับใช้ต่อไป "
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "ในการเข้าใช้บริการของบีนีทแพลตฟอร์ม ท่านได้อ่านและยอมรับเงื่อนไขทุกประการตามข้อตกลงนี้ รวมถึงท่านได้ยินยอมผูกพันตนตามเงื่อนไขที่อาจจะได้มีการแก้ไขหรือปรับปรุงในอนาคต และหมายความรวมไปถึงว่าท่านเข้าใจและเห็นชอบกับข้อตกลงดังกล่าวด้วย และการที่ท่านใช้บริการภายหลังจากการแก้ไขหรือปรับปรุงเงื่อนไขตามข้อตกลงนี้ ถือว่าท่านยอมรับเงื่อนไขดังกล่าวซึ่งบริษัทได้ปรับปรุงและแก้ไขแล้วด้วย"
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "ข้อตกลงนี้อาจลงนามโดยลายเซ็นอิเล็กทรอนิกส์ ท่านได้อ่านและเข้าใจเนื้อหาในข้อตกลงนี้ดีแล้ว รวมถึงยอมรับเงื่อนไขตามที่ปรากฏในข้อตกลงทุกประการ ทั้งนี้ ท่านเข้าใจดีว่าลายเซ็นอิเล็กทรอนิกส์มีผลผูกมัดตามกฎหมายเช่นเดียวกับการลงลายมือชื่อ"
                )
              ])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f4b537c2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4b537c2","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/Term.vue
// module id = 1460
// module chunks = 0